export function classifyScore(raw: unknown) {
  const score = Number(raw);
  if (!Number.isFinite(score)) {
    return {
      label: "Sem nota",
      className: "bg-surface text-muted border-border",
    };
  }
  if (score <= 0.75) {
    return {
      label: "Insuficiente",
      className: "bg-red/10 text-red border-red/20",
    };
  }
  if (score <= 1.5) {
    return {
      label: "Regular",
      className: "bg-warn/20 text-gray border-warn/40",
    };
  }
  if (score <= 2.25) {
    return {
      label: "Bom",
      className: "bg-primaryLight text-primaryDark border-primary/20",
    };
  }
  return {
    label: "Ótimo",
    className: "bg-primary text-white border-primary",
  };
}

export function formatScore(raw: unknown) {
  const score = Number(raw);
  if (!Number.isFinite(score)) {
    return "—";
  }
  return score.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function softenCaps(text: string) {
  const value = text.trim();
  const letters = value.replace(/[^A-Za-zÀ-ÿ]/g, "");
  if (!letters) {
    return value;
  }
  const caps = Array.from(letters).filter(
    (char) => char === char.toUpperCase() && char !== char.toLowerCase()
  ).length;
  if (caps / letters.length < 0.7) {
    return value;
  }
  const small = new Set(["de", "da", "do", "das", "dos", "e", "a", "o", "em"]);
  return value
    .toLocaleLowerCase("pt-BR")
    .split(/(\s+|\/)/)
    .map((part, index) => {
      if (!part.trim() || part === "/") {
        return part;
      }
      const lower = part.toLocaleLowerCase("pt-BR");
      if (index > 0 && small.has(lower)) {
        return lower;
      }
      return lower.charAt(0).toLocaleUpperCase("pt-BR") + lower.slice(1);
    })
    .join("");
}

export function formatScoreHeading(nome: unknown) {
  const raw = softenCaps(String(nome ?? "").trim());
  const separator = raw.includes(" - ")
    ? " - "
    : raw.includes(" – ")
      ? " – "
      : "-";
  const [group, ...rest] = raw.split(separator);
  return {
    group: group || "Pontuação",
    result: rest.join(separator).trim() || "Resultado",
  };
}

